module.exports = __webpack_public_path__ + "img/PVP_NorseTechTowerFreyja1_ua.91c9e4f8.webp";